<!-- NAVIGATION -->
<nav class="fixed top-0 left-0 right-0 z-[1000] bg-white border-b border-neutral-gray-200 font-poppins">
  <div class="flex justify-between items-center h-[60px] pl-6 pr-3 w-full max-w-[1200px] mx-auto">
    <!-- Logo CANTERA -->
    <button (click)="goToHome()" class="flex-shrink-0">
      <img src="assets/icons/new-logo-header.svg" alt="CANTERA" class="h-10 w-auto" />
    </button>

    <!-- Grupo de botones derecha -->
    <div class="flex items-center gap-3 flex-shrink-0">
      <!-- Botón Ingresar -->
      <button
        (click)="goToLogin()"
        class="bg-cantera-red-primary font-poppins text-white px-4 py-2.5 rounded-lg font-semibold text-xs flex items-center gap-2 hover:bg-[#B71C1A] transition-colors h-10 flex-shrink-0"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="flex-shrink-0">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Ingresar
      </button>

      <!-- Botón menú hamburguesa -->
      <button
        class="bg-neutral-gray-200 rounded-lg w-10 h-10 min-w-[40px] flex items-center justify-center hover:bg-neutral-gray-300 transition-colors flex-shrink-0"
        (click)="toggleMenu()"
      >
        <app-svg-icon [iconName]="SvgIcon.MENU" [size]="24"></app-svg-icon>
      </button>
    </div>
  </div>
</nav>

<!-- Overlay oscuro -->
<div 
  *ngIf="isMenuOpen"
  class="fixed inset-0 z-[1001] bg-black bg-opacity-50 transition-opacity"
  (click)="closeMenu()"
></div>

<!-- Menú lateral -->
<div 
  class="fixed top-0 right-0 bottom-0 w-full sm:max-w-[375px] bg-neutral-gray-100 z-[1002] shadow-xl transform transition-transform duration-300 ease-in-out flex flex-col"
  [class.translate-x-0]="isMenuOpen"
  [class.translate-x-full]="!isMenuOpen"
>
  <!-- Header del menú -->
  <div class="bg-white px-4 py-4 flex items-center justify-between border-b border-neutral-gray-200 flex-shrink-0">
    <!-- Logo CANTERA -->
    <button (click)="goToHome(); closeMenu()">
      <img src="assets/icons/new-logo-header.svg" alt="CANTERA" class="h-10 w-auto" />
    </button>
    
    <!-- Botones derecha -->
    <div class="flex items-center gap-3">
      <!-- Botón Ingresar -->
      <button
        (click)="goToLogin(); closeMenu()"
        class="bg-cantera-red-primary text-xs font-poppins text-white px-4 py-2 rounded-lg font-semibold flex items-center gap-2 hover:bg-[#B71C1A] transition-colors h-10"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Ingresar
      </button>
      
      <!-- Botón cerrar -->
      <button
        (click)="closeMenu()"
        class="w-10 h-10 flex items-center justify-center rounded-lg bg-neutral-gray-200 hover:bg-neutral-gray-300 transition-colors"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" stroke="#20202A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Contenido central - arriba -->
  <div class="flex-1 overflow-y-auto px-4 py-6" (scroll)="onMenuScroll($event)">
    <!-- Sección: ¿Qué vas hacer hoy? -->
    <h2 class="text-neutral-gray-900 text-[18px] font-poppins font-semibold mb-4 text-center">¿Qué vas hacer hoy?</h2>
    
    <div class="flex flex-col gap-3">
      <!-- Menu buttons -->
      <ds-menu-button 
        *ngFor="let button of menuButtons; let i = index"
        [data]="button"
        (click)="onMenuButtonClick(i)"
      ></ds-menu-button>
    </div>
  </div>

  <!-- Footer del menú - fijo abajo -->
  <div class="bg-neutral-gray-100 px-4 py-6 flex-shrink-0">
    <!-- Sección: ¿Aún no estás en Cantera? -->
    <h3 class="text-neutral-gray-900 font-poppins text-[16px] font-semibold mb-4 text-center">¿Aún no estás en Cantera?</h3>
    <button
      (click)="goToRegister()"
      class="w-full bg-cantera-red-primary text-[16px] text-white px-6 py-4 rounded-xl font-poppins font-bold text-base flex items-center justify-center gap-2 hover:bg-[#B71C1A] transition-colors mb-4"
    >
      <span>Unirme a Cantera</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.17712e-08 6.85765C0.000179064 6.22671 0.511634 5.71522 1.14258 5.71507L12.0986 5.71507L8.33496 1.9514C7.88872 1.50508 7.88867 0.781477 8.33496 0.335187C8.78127 -0.110824 9.50495 -0.110966 9.95117 0.335187L15.665 6.05003C15.6918 6.07676 15.7172 6.10475 15.7412 6.13402C15.7788 6.17978 15.8105 6.22879 15.8398 6.27855C15.8481 6.29249 15.8566 6.30622 15.8643 6.32054C15.8723 6.33563 15.8794 6.35108 15.8867 6.36644C15.8957 6.38521 15.9051 6.40375 15.9131 6.42308C15.9213 6.44306 15.9285 6.4633 15.9355 6.48363C15.9399 6.49626 15.9443 6.50888 15.9482 6.52171C15.9576 6.55209 15.9659 6.58259 15.9727 6.61351C15.9739 6.61906 15.9754 6.62453 15.9766 6.63011C15.9995 6.74334 16.0058 6.85925 15.9941 6.97386C15.9937 6.97812 15.9927 6.98231 15.9922 6.98655C15.9842 7.05722 15.9694 7.12707 15.9482 7.19554C15.945 7.20609 15.9411 7.21637 15.9375 7.22679C15.9298 7.24937 15.9222 7.27201 15.9131 7.29417C15.9051 7.31348 15.8957 7.33205 15.8867 7.35081C15.8794 7.36602 15.8732 7.38177 15.8652 7.39671C15.8532 7.41916 15.8396 7.44062 15.8262 7.46214C15.8205 7.47117 15.8155 7.48058 15.8096 7.48948C15.7955 7.51067 15.7801 7.53084 15.7646 7.55101C15.7566 7.56151 15.7497 7.57295 15.7412 7.58323C15.7174 7.61228 15.6916 7.6397 15.665 7.66624L9.95117 13.3801C9.50486 13.8264 8.78127 13.8264 8.33496 13.3801C7.88865 12.9338 7.88865 12.2102 8.33496 11.7639L12.0977 8.0012L1.14258 8.0012C0.511524 8.00105 7.42455e-08 7.48874 8.17712e-08 6.85765Z" fill="white"/>
</svg>
    </button>

    <!-- Enlace propietario -->
    <div class="text-center">
      <span class="text-[14px] text-neutral-gray-900 font-poppins font-normal">¿Eres Propietario? </span>
      <button
        (click)="goToOwner()"
        class="text-cantera-red-primary text-[14px] font-poppins font-semibold hover:underline"
      >
        Ingresa aquí
      </button>
    </div>
  </div>
</div>


<!-- Espaciador para compensar el header fijo -->
<div class="h-[60px]"></div>

